import { ReportSubscription } from "@/model/data/reportSubscription/ReportSubscription";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetReportSubscriptionResData extends ServiceResponseData {
    reportSubscriptions: ReportSubscription[];

    constructor(response: AxiosResponse) {
        super(response);
        this.reportSubscriptions = [];
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.ReportSubscription && obj.ReportSubscription.length > 0) {
            obj.ReportSubscription.forEach((e) => {
                var rs = new ReportSubscription();
                rs.parse(e);

                this.reportSubscriptions.push(rs);
            });
        }
    }
}
